<template>
    <FormKit
        type="checkbox"
        :name="name"
        :value="value"
        :validation-rules="validationRules"
        :validation="validation"
        :classes="{
            wrapper: 'inline-flex items-center cursor-pointer text-2xs',
            message: 'text-bbk-claret text-2xs text-right lowercase',
            inner: `mr-4${props.isHtml && ' self-start'}`,
            input: 'hidden',
        }"
        :outer-class="outerClass"
        :validation-messages="{
            accepted: $t('Bbk.form.validator.required'),
            dependableRequired: $t('Bbk.form.validator.dependableRequired'),
        }"
    >
        <template #decorator="{ value }">
            <div
                class="flex items-center justify-center relative border border-black rounded-full min-w-[24px] w-6 h-6"
                :class="{
                    'bg-black': value,
                }"
            >
                <ShcUiIcon v-if="value" name="check" class="text-white" />
            </div>
        </template>
        <template #label>
            <span v-if="isRequired" class="after:content-['*']"></span>
            <slot name="label" />
        </template>
    </FormKit>
</template>

<script lang="ts" setup>
    import type { Props } from './props'

    const props = defineProps<Props>()
    const isRequired = computed(() => typeof props.validation === 'string' && props.validation.includes('required'))
</script>
